import {useEffect, useState} from 'react';

import {AppButton} from '@/components/Button';
import appContent from '@/services/content/appContent.typed';

import {useAutoDeliveryDcxContext} from '../../AutoDeliveryDcxContext';
import ReschedulePopup from './ReschedulePopup/ReschedulePopup';

interface StatusActiveRescheduleButtonProps {
    className?: string;
}

const StatusActiveRescheduleButton = ({className}: StatusActiveRescheduleButtonProps) => {
    const {openRescheduleRequested, setOpenRescheduleRequested} = useAutoDeliveryDcxContext();
    const [isPopupOpen, setIsPopupOpen] = useState(false);
    const content = appContent.getAutoDeliveryContent()?.extendedDetailsContent || {};
    const {rescheduleButton} = content;

    useEffect(() => {
        if (openRescheduleRequested) {
            setOpenRescheduleRequested(false);
            setIsPopupOpen(true);
        }
    }, [openRescheduleRequested]);

    if (!rescheduleButton) {
        return null;
    }

    return (
        <div>
            <AppButton
                primary
                light
                className={className}
                onClick={() => setIsPopupOpen(true)}
                aria-label={rescheduleButton.alt}
            >
                {rescheduleButton.text}
            </AppButton>
            <ReschedulePopup isOpen={isPopupOpen} onClose={() => setIsPopupOpen(false)} />
        </div>
    );
};

export default StatusActiveRescheduleButton;
